import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGrilla = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grilla',
        name: 'Grilla',
        component: ViewGrilla,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
